// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"d8fcf434","298":"b865e8ce","377":"1f5a86e8","488":"37f1b091","917":"7e1cd939"}[chunkId] + ".chunk.js";
};